import { DiContainer } from '@jack-henry/frontend-utils/di';
import { DynamicComponentResult } from '@jack-henry/frontend-utils/lit/dynamic-component-registry';
import { TmDialogButtonPosture, TmDialogService } from '@treasury/presentation/services/dialog';

type PaymentType = 'ACH' | 'Transfer' | 'User' | 'Loan' | 'Wire' | 'Stop Payment';

let dialogPromise: Promise<DynamicComponentResult<'Approved' | 'Rejected'>> | undefined;

export async function showApproveRejectPrompt(
    paymentType: PaymentType | Lowercase<PaymentType>,
    action: 'approve' | 'reject',
    paymentOrTemplate: 'payment' | 'template' = 'payment'
) {
    const di = await DiContainer.getInstance();
    const dialogService = await di.getAsync(TmDialogService);

    if (dialogPromise) {
        return dialogPromise;
    }

    const approvalText = getApprovalText(
        paymentType.toLowerCase() as Lowercase<PaymentType>,
        paymentOrTemplate
    );
    const message = `Are you sure you want to ${action} this ${approvalText}?`;

    dialogPromise = dialogService
        .open<void>(message, 'Confirm Decision', {
            buttons: {
                [TmDialogButtonPosture.Primary]: {
                    label: 'Yes',
                },
                [TmDialogButtonPosture.Secondary]: {
                    label: 'No',
                },
            },
        })
        // coerce action into data to be used approval/rejection endpoint
        // since they all rely on one of two string values
        .then(({ reason }) => ({
            reason,
            data: action === 'approve' ? 'Approved' : 'Rejected',
        }));

    dialogPromise.finally(() => (dialogPromise = undefined));

    return dialogPromise;
}

function getApprovalText(
    paymentTypeLowercase: Lowercase<PaymentType>,
    paymentOrTemplate: 'payment' | 'template'
) {
    return paymentTypeLowercase === 'user'
        ? paymentTypeLowercase
        : `${paymentTypeLowercase} ${paymentOrTemplate}`;
}
